import Cookies from 'universal-cookie';

const cookies = new Cookies();

const withCookieData = <T extends {}>(obj: T, cookieKey: string) => {
  const cookieVal = cookies.get<string>(cookieKey);

  return cookieVal ? { ...obj, [cookieKey]: cookieVal } : obj;
};

export default withCookieData;
